import { API_BASE_URL, request } from './request';

const postStatistics = async (path, payload = {}) => request(`${API_BASE_URL}${path}`, {
  method: 'POST',
  body: JSON.stringify(payload),
});

export const getBillingPlans = async () => request(`${API_BASE_URL}/billing/plans`);
export const getPublicPlans = async () => request(`${API_BASE_URL}/public/plans`);
export const previewBillingPlans = async (payload = {}) => request(`${API_BASE_URL}/billing/plans/preview`, {
  method: 'POST',
  body: JSON.stringify(payload),
});

export const createCheckout = async (payloadOrPlanId, options = {}) => {
  const payload = typeof payloadOrPlanId === 'object' && payloadOrPlanId !== null
    ? payloadOrPlanId
    : { plan_id: payloadOrPlanId, ...options };
  return request(`${API_BASE_URL}/billing/checkout`, {
    method: 'POST',
    body: JSON.stringify(payload),
  });
};

export const getSubscription = async () => request(`${API_BASE_URL}/billing/subscription`);
export const getBillingQuota = async () => request(`${API_BASE_URL}/billing/quota`);
export const getBillingCredits = async () => request(`${API_BASE_URL}/billing/credits`);
export const getCreditHistory = async (params = {}) => {
  const page = Number(params.page || 1);
  const pageSize = Number(params.page_size || params.pageSize || 10);
  const query = new URLSearchParams({
    page: String(page > 0 ? page : 1),
    page_size: String(pageSize > 0 ? pageSize : 10),
  });
  const entryType = String(params.entry_type || params.entryType || '').trim();
  if (entryType) query.set('entry_type', entryType);
  return request(`${API_BASE_URL}/billing/credit-history?${query.toString()}`);
};
export const getCreditPacks = async () => request(`${API_BASE_URL}/billing/credit-packs`);
export const estimateBillingCredits = async (payload = {}) => request(`${API_BASE_URL}/billing/credits/estimate`, {
  method: 'POST',
  body: JSON.stringify(payload),
});
export const createCreditPackCheckout = async (payload = {}) => request(`${API_BASE_URL}/billing/credit-packs/checkout`, {
  method: 'POST',
  body: JSON.stringify(payload),
});
export const redeemSubscriptionCode = async (payload = {}) => request(`${API_BASE_URL}/billing/redeem`, {
  method: 'POST',
  body: JSON.stringify(payload),
});
export const getSubscriptionHistory = async (params = {}) => {
  const page = Number(params.page || 1);
  const pageSize = Number(params.page_size || params.pageSize || 10);
  const query = new URLSearchParams({
    page: String(page > 0 ? page : 1),
    page_size: String(pageSize > 0 ? pageSize : 10),
  });
  return request(`${API_BASE_URL}/billing/subscription/history?${query.toString()}`);
};
export const getPaymentStatus = async (outTradeNo) => request(`${API_BASE_URL}/billing/payment/${encodeURIComponent(outTradeNo)}`);
export const reconcilePaymentStatus = async (outTradeNo) => request(
  `${API_BASE_URL}/billing/payment/${encodeURIComponent(outTradeNo)}/reconcile`,
  { method: 'POST', body: JSON.stringify({}) }
);

export const getStatisticsFilterOptions = async (payload = {}) => postStatistics('/statistics/filters/options', payload);
export const getProductionStatisticsOverview = async (payload = {}) => postStatistics('/statistics/production/overview', payload);
export const getProductionStatisticsQuery = async (payload = {}) => postStatistics('/statistics/production/query', payload);
export const getPublishStatisticsOverview = async (payload = {}) => postStatistics('/statistics/publish/overview', payload);
export const getPublishStatisticsQuery = async (payload = {}) => postStatistics('/statistics/publish/query', payload);
export const getPublishFailureReasons = async (payload = {}) => postStatistics('/statistics/publish/failure-reasons', payload);
export const getEffectStatisticsOverview = async (payload = {}) => postStatistics('/statistics/effect/overview', payload);
export const getEffectStatisticsQuery = async (payload = {}) => postStatistics('/statistics/effect/query', payload);
export const syncEffectStatistics = async (payload = {}) => postStatistics('/statistics/effect/sync', payload);
export const collectXhsEffectStatistics = async (payload = {}) => postStatistics('/statistics/effect/collect/xhs', payload);
export const createEffectCollectTask = async (payload = {}) => postStatistics('/statistics/effect/tasks/create', payload);
export const listEffectCollectTasks = async (payload = {}) => postStatistics('/statistics/effect/tasks/list', payload);
export const updateEffectCollectTask = async (payload = {}) => postStatistics('/statistics/effect/tasks/update', payload);
export const deleteEffectCollectTask = async (payload = {}) => postStatistics('/statistics/effect/tasks/delete', payload);
export const triggerEffectCollectTaskOnce = async (payload = {}) => postStatistics('/statistics/effect/tasks/trigger_once', payload);
export const getActiveEffectCollectTaskRuns = async (payload = {}) => postStatistics('/statistics/effect/tasks/active_runs', payload);
